import React from 'react';
import { css } from 'styled-components';

// Components
import Layout from 'src/components/common/theme/Layout';

//helpers
import { getDeviceImage } from 'src/components/common/theme/component';

//types
import { HeroLogoProps } from '../../typings';
import { checkValue } from 'src/components/common/helper';

const HeroLogo: React.FC<HeroLogoProps> = (props) => {
  const { heroLogo, heroLogoMobile, heroLogoStyle, heroLogoWidth, heroLogoHeight } = props;
  const windowWidth = window?.innerWidth;
  let deviceSize = 'desktop';
  if(checkValue(heroLogoMobile)){
    if (windowWidth < 768) deviceSize = 'mobile';
  }

  const heroLogoImage = (deviceSize === 'mobile') ? getDeviceImage(heroLogoMobile, 'desktop') : getDeviceImage(heroLogo, 'desktop');
  const heroLogoAlign = checkValue(heroLogoStyle) ? heroLogoStyle.replace(/\s/g, '').toLowerCase() : 'left';
  const isHeroLogoTop = heroLogoAlign === 'topleft' || heroLogoAlign === 'topright' ? 'top' : '';

  const moduleCss = () => {
    return `
        &.hero-logo-component {
          .hero-logo-image {
            ${heroLogoWidth !== '' ? `max-width: ${heroLogoWidth}px !important;` : ''}
            ${heroLogoHeight !== '' ? `max-height: ${heroLogoHeight}px !important;` : ''}              
          }
          &.center-bottom{
            ${
              (deviceSize === 'mobile')
                ? `
                .hero-logo-image{
                  max-width: 200px !important;
                  width: auto;
                  height: auto;
                  max-height: 110px !important;
                }
                ` : ''
            
          }
        }
    `;
  };

  return (
    <Layout
      css={css`
        ${moduleCss()}
      `}
      className={`hero-logo-component ${heroLogoAlign} ${isHeroLogoTop}`}
    >
      <img className="hero-logo-image" src={heroLogoImage} />
    </Layout>
  );
};

export default HeroLogo;
